export class MppNotificationError extends Error {
  public constructor(public readonly key: string, public readonly params?: Record<string, any>) {
    super(key);
  }
}
